function formatNoteTime(value) {
    if (!value) {
        return "";
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return value;
    }
    return date.toLocaleString([], {
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
    });
}

function NotesTab({
    notes = [],
    notesLoading = false,
    notesError = "",
    notesSaving = false,
    noteDraft = "",
    onNoteDraftChange,
    onAddNote,
}) {
    const currentDraft = String(noteDraft || "");
    const trimmedDraft = currentDraft.trim();
    const noteRows = Array.isArray(notes) ? notes : [];
    const canSave = !notesSaving && trimmedDraft.length > 0;

    return (
        <section className="tab-panel-container tab-panel-container--notes" aria-label="Notes tab">
            <header className="tab-panel-header">
                <div>
                    <h3>Notes</h3>
                    <p className="tab-panel-subtitle">Private note log for this contact.</p>
                </div>
                <div className="tab-panel-actions">
                    <button
                        type="button"
                        className="tab-panel-btn tab-panel-btn--primary"
                        onClick={() => onAddNote?.(currentDraft)}
                        disabled={!canSave}
                    >
                        {notesSaving ? "Saving..." : "Add Note"}
                    </button>
                </div>
            </header>

            <div className="contact-notes-body">
                <textarea
                    className="contact-notes-textarea contact-notes-textarea--composer"
                    value={currentDraft}
                    onChange={(event) => onNoteDraftChange?.(event.target.value)}
                    placeholder="Write a note and save it to the contact log..."
                    rows={5}
                />

                {notesError ? <p className="contact-notes-error">{notesError}</p> : null}

                {notesLoading ? (
                    <p className="contact-detail-tab-empty">Loading notes...</p>
                ) : noteRows.length === 0 ? (
                    <p className="contact-detail-tab-empty">No notes yet. Add the first one above.</p>
                ) : (
                    <div className="contact-notes-list">
                        {noteRows.map((note) => (
                            <article key={String(note.id)} className="contact-notes-card">
                                <div className="contact-notes-card__meta">
                                    <strong>{note.user_name || "Unknown user"}</strong>
                                    <span>{formatNoteTime(note.created_at)}</span>
                                </div>
                                <p className="contact-notes-card__content">{note.content || ""}</p>
                            </article>
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
}

export default NotesTab;
